import Popup from "../../utils/popup";
import CartShort from "../../utils/cart-short";

class Darowizna {
    constructor() {
        this.cartShort = new CartShort();
    }

    events() {
        const that = this;
        $("#kwoty-darowizny .donor__amount-value").off('click').on("click", function (e) {
            $("#darowizna-kwota_inna").parents(".form-group").hide();
            $("#darowizna-kwota_inna").val("").trigger("keyup");
            $("#kwoty-darowizny .donor__amount-value").removeClass(
                "donor__amount-value--selected"
            );

            $(this).addClass("donor__amount-value--selected");

            if ($(this).hasClass("donor__amount-value--other")) {
                $("#darowizna-kwota_inna").parents(".form-group").show();
            } else {
                $("#darowizna-kwota").val($(this).data("kwota"));
            }

            that.saveSelectedInSession();
        });

        $("#darowizna-kwota_inna").on("blur", function (e) {
            $("#darowizna-kwota").val($(this).val());
            that.saveSelectedInSession();
        });

        // $("#kwoty-darowizny .donor__amount-item:first .donor__amount-value").trigger(
        //     "click"
        // );

        $('#darowizna-cel').change(function () {
            that.saveSelectedInSession();
        });

        $("form").submit(function (event) {
            $("#darowizna-kwota_inna").rules("add", {
                required: $("#kwoty-darowizny .donor__amount-value--selected").hasClass(
                    "donor__amount-value--other"
                ),
            });

            if ($(this).valid() === false) {
                event.preventDefault();
            }
        });

    }

    saveSelectedInSession() {

        let preselectedAmount = $('.donor__amount-value.donor__amount-value--selected').data("kwota");
        if (!preselectedAmount) {
            preselectedAmount = null;
        }
        let otherAmount = $('#darowizna-kwota_inna').val();

        if (!otherAmount) {
            otherAmount = null;
        }

        let donationPurpose = $('select#darowizna-cel').val();
        if (!donationPurpose) {
            donationPurpose = null;
        }


        $.ajax({
            url: '/darowizny/dodaj.html',
            method: 'get',
            data: {
                ajax: 'saveSelectedInSession',
                preselectedAmount: preselectedAmount,
                otherAmount: otherAmount,
                donationPurpose: donationPurpose
            }
        });
    }

    getSelectedFromSession() {
        $.ajax({
            url: '/darowizny/dodaj.html',
            method: 'get',
            data: {
                ajax: 'getSelectedFromSession',
            },
            success: function (result) {
                if (result && result.status === 'complete') {
                    if(parseInt(result.data.donationPurpose) > 0) {
                        $('#darowizna-cel').val(parseInt(result.data.donationPurpose));
                    }

                    if (result.data.otherAmount) {
                        $('#kwoty-darowizny .donor__amount-item:last .donor__amount-value').trigger(
                            "click"
                        );
                        $('#darowizna-kwota_inna').val(result.data.otherAmount);
                    } else if (result.data.preselectedAmount > 0) {
                        $('#kwoty-darowizny .donor__amount-item .donor__amount-value[data-kwota="' + result.data.preselectedAmount + '"]').trigger(
                            "click"
                        );
                    } else {
                        $('#kwoty-darowizny .donor__amount-item:first .donor__amount-value').trigger(
                            "click"
                        );
                    }
                }
            }
        });
    }

    init() {
        this.getSelectedFromSession();
        this.events();

    }
}

export default Darowizna;
